// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__FxQfo","containerWithMenu":"Layout_containerWithMenu__BhLcM","lateral":"Layout_lateral__PV7-k","content":"Layout_content__fwmv4"};